/*
 * Copyright (c) 2022. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Grid from "@mui/material/Grid";
import FormLegend from "../../Common/FormLegend/FormLegend";
import { translate, translateHelperTextIfExists } from "../../../../services/translations/translations";
import ValidatorDateField from "../../../FormFields/ValidatorDateField";
import { dateFieldDefault, pastDateDefault, pastOrSameDateDefault, requiredValidator } from "../../../../services/validationRules";

type DateFieldConfiguredProps = {
  caseData: Record<string, any>;
  fieldPath: string;
  dateValidation?: "past" | "pastOrToday";
  required?: boolean | undefined;
};

export default function DateFieldConfigured({
  caseData,
  fieldPath,
  dateValidation,
  required = false,
}: DateFieldConfiguredProps) {
  const validators = [dateFieldDefault];
  if (required) {
    validators.push(requiredValidator());
  }
  if (dateValidation === "pastOrToday") {
    validators.push(pastOrSameDateDefault);
  }
  if (dateValidation === "past") {
    validators.push(pastDateDefault);
  }
  const helperText = translateHelperTextIfExists(caseData, fieldPath);
    const question = translate(`${caseData.name}.${fieldPath}.question`, caseData);
    const label = translate(`${caseData.name}.${fieldPath}.label`, caseData);

  return (
    <>
      <Grid size={12}>
        <FormLegend>{question}</FormLegend>
      </Grid>
      <Grid size={12}>
        <ValidatorDateField label={label} name={fieldPath} helperText={helperText} validators={validators} />
      </Grid>
    </>
  );
}
